// extracted by mini-css-extract-plugin
export default {"wrap":"HG-z","fullWidth":"IG-z","hideOnDesktop":"JG-z","content":"KG-z","hasOpenedNav":"LG-z","crumbsList":"MG-z","dropdownsWrap":"NG-z"};